import React from 'react'

const PagesMainLayout = props => {
  return (
    <main className="mx-auto px-0 xxl:px-3 py-10 flex-1 lg:flex-none lg:w-8/12 lg:px-3">
      {props.children}
    </main>
  )
}

export default PagesMainLayout
